'use strict';

module.exports = {
    getOperatorCodeMap: function () {
        var kvArray = [
            [
                41201,
                "AWCC"
            ],
            [
                41240,
                "Areeba"
            ],
            [
                41250,
                "Etisalat"
            ],
            [
                41220,
                "Roshan"
            ],
            [
                27601,
                "AMC"
            ],
            [
                27603,
                "Eagle Mobile"
            ],
            [
                27604,
                "Plus Communication"
            ],
            [
                27602,
                "Vodafone"
            ],
            [
                60302,
                "Djezzy"
            ],
            [
                60301,
                "Mobilis"
            ],
            [
                60303,
                "Nedjma"
            ],
            [
                54411,
                "Bluesky"
            ],
            [
                21303,
                "Mobiland"
            ],
            [
                63104,
                "MOVICEL"
            ],
            [
                63102,
                "UNITEL"
            ],
            [
                365840,
                "Cable & Wireless"
            ],
            [
                365010,
                "Weblinks Limited"
            ],
            [
                344030,
                "APUA"
            ],
            [
                344920,
                "bmobile"
            ],
            [
                344930,
                "Digicel"
            ],
            [
                722310,
                "Claro"
            ],
            [
                722320,
                "Claro"
            ],
            [
                722330,
                "Claro"
            ],
            [
                722350,
                "Hutchinson (PORT HABLE)"
            ],
            [
                722010,
                "Movistar"
            ],
            [
                722070,
                "Movistar"
            ],
            [
                722020,
                "Nextel"
            ],
            [
                72234,
                "Personal"
            ],
            [
                722341,
                "Telecom Personal SA"
            ],
            [
                72236,
                "Telecom Personal SA"
            ],
            [
                28301,
                "Beeline"
            ],
            [
                28310,
                "Orange"
            ],
            [
                28305,
                "VivaCell-MTS"
            ],
            [
                36302,
                "Digicel"
            ],
            [
                36320,
                "Digicell"
            ],
            [
                36301,
                "SETAR"
            ],
            [
                50506,
                "3"
            ],
            [
                50512,
                "3"
            ],
            [
                50515,
                "3GIS"
            ],
            [
                50514,
                "AAPT"
            ],
            [
                50524,
                "Advanced Communications Technologies"
            ],
            [
                50509,
                "Airnet"
            ],
            [
                50538,
                "Crazy John's"
            ],
            [
                50504,
                "Department of Defence"
            ],
            [
                50588,
                "Localstar"
            ],
            [
                50510,
                "Norfolk Telecom"
            ],
            [
                50508,
                "One. Tel"
            ],
            [
                50599,
                "One. Tel"
            ],
            [
                50502,
                "OPTUS / Virgin Mobile"
            ],
            [
                50505,
                "Ozitel"
            ],
            [
                50513,
                "Railcorp"
            ],
            [
                50521,
                "SOUL"
            ],
            [
                50501,
                "Telstra"
            ],
            [
                50511,
                "Telstra"
            ],
            [
                50571,
                "Telstra"
            ],
            [
                50572,
                "Telstra"
            ],
            [
                50516,
                "Victorian Rail Track"
            ],
            [
                50503,
                "Vodafone"
            ],
            [
                50507,
                "Vodafone"
            ],
            [
                50590,
                "YES OPTUS"
            ],
            [
                23210,
                "3"
            ],
            [
                23214,
                "3"
            ],
            [
                23201,
                "A1"
            ],
            [
                23209,
                "A1"
            ],
            [
                23215,
                "Barablu"
            ],
            [
                23211,
                "bob"
            ],
            [
                23291,
                "GSM-R A"
            ],
            [
                23205,
                "Orange"
            ],
            [
                23203,
                "T-Mobile"
            ],
            [
                23207,
                "T-Mobile"
            ],
            [
                23212,
                "yesss"
            ],
            [
                40001,
                "Azercell"
            ],
            [
                40002,
                "Bakcell"
            ],
            [
                40003,
                "FONEX"
            ],
            [
                40004,
                "Nar Mobile"
            ],
            [
                364390,
                "BaTelCo"
            ],
            [
                42601,
                "Batelco"
            ],
            [
                42602,
                "MTC-VFBH"
            ],
            [
                42604,
                "VIVA"
            ],
            [
                47002,
                "Aktel"
            ],
            [
                47003,
                "Banglalink"
            ],
            [
                47005,
                "Citycell"
            ],
            [
                47006,
                "Citycell"
            ],
            [
                47001,
                "Grameenphone"
            ],
            [
                47004,
                "TeleTalk"
            ],
            [
                47007,
                "Warid"
            ],
            [
                342600,
                "bmobile"
            ],
            [
                342750,
                "Digicel"
            ],
            [
                342820,
                "Sunbeach Communications"
            ],
            [
                257501,
                "BelCel JV"
            ],
            [
                25703,
                "DIALLOG"
            ],
            [
                25704,
                "life:)"
            ],
            [
                25702,
                "MTS"
            ],
            [
                25701,
                "Velcom"
            ],
            [
                20620,
                "BASE"
            ],
            [
                20610,
                "Mobistar"
            ],
            [
                20601,
                "Proximus"
            ],
            [
                20605,
                "Telenet"
            ],
            [
                70267,
                "Belize Telemedia"
            ],
            [
                70268,
                "International Telecommunications Ltd."
            ],
            [
                70299,
                "Smart"
            ],
            [
                61603,
                "Areeba"
            ],
            [
                61600,
                "BBCOM"
            ],
            [
                61604,
                "BBCOM"
            ],
            [
                61605,
                "Glo"
            ],
            [
                61601,
                "Libercom"
            ],
            [
                61602,
                "Telecel"
            ],
            [
                31038,
                "Digicel"
            ],
            [
                35001,
                "Digicel Bermuda"
            ],
            [
                35002,
                "Mobility"
            ],
            [
                40211,
                "B-Mobile"
            ],
            [
                40277,
                "TashiCell"
            ],
            [
                73602,
                "Entel"
            ],
            [
                73601,
                "Nuevatel"
            ],
            [
                73603,
                "Tigo"
            ],
            [
                21890,
                "BH Mobile"
            ],
            [
                21803,
                "ERONET"
            ],
            [
                21805,
                "m:tel"
            ],
            [
                65204,
                "BTC Mobile"
            ],
            [
                65201,
                "Mascom"
            ],
            [
                65202,
                "Orange"
            ],
            [
                72437,
                "aiou"
            ],
            [
                72424,
                "Amazonia Celular"
            ],
            [
                72416,
                "Brasil Telecom"
            ],
            [
                72405,
                "Claro"
            ],
            [
                72432,
                "CTBC Cellular"
            ],
            [
                72433,
                "CTBC Cellular"
            ],
            [
                72434,
                "CTBC Cellular"
            ],
            [
                72407,
                "CTBC Celular"
            ],
            [
                72400,
                "Nextel"
            ],
            [
                72439,
                "Nextel"
            ],
            [
                72415,
                "Sercomtel"
            ],
            [
                72402,
                "TIM"
            ],
            [
                72403,
                "TIM"
            ],
            [
                72404,
                "TIM"
            ],
            [
                72408,
                "TIM"
            ],
            [
                72431,
                "TNL PCS"
            ],
            [
                72406,
                "Vivo"
            ],
            [
                72410,
                "Vivo"
            ],
            [
                72411,
                "Vivo"
            ],
            [
                72423,
                "Vivo"
            ],
            [
                348170,
                "Cable & Wireless"
            ],
            [
                348570,
                "Caribbean Cellular Telephone"
            ],
            [
                348770,
                "Digicel"
            ],
            [
                52802,
                "B-Mobile"
            ],
            [
                52811,
                "DTSCom"
            ],
            [
                52801,
                "Jabatan Telekom"
            ],
            [
                28405,
                "GLOBUL"
            ],
            [
                28401,
                "M-Tel"
            ],
            [
                28404,
                "Undisclosed"
            ],
            [
                28403,
                "Vivatel"
            ],
            [
                61301,
                "Onatel"
            ],
            [
                61303,
                "Telecel Faso"
            ],
            [
                61302,
                "Zain"
            ],
            [
                64202,
                "Africell"
            ],
            [
                64208,
                "HiTs Telecom"
            ],
            [
                64207,
                "Smart Mobile"
            ],
            [
                64201,
                "Spacetel"
            ],
            [
                64203,
                "Telecel"
            ],
            [
                64282,
                "U-COM Burundi"
            ],
            [
                45609,
                "Beeline"
            ],
            [
                45618,
                "Camshin / Shinawatra"
            ],
            [
                45611,
                "Excell"
            ],
            [
                45602,
                "hello"
            ],
            [
                45608,
                "Metfone"
            ],
            [
                45601,
                "Mobitel"
            ],
            [
                45604,
                "qb"
            ],
            [
                45603,
                "S Telecom"
            ],
            [
                45606,
                "Smart Mobile"
            ],
            [
                45605,
                "Star-Cell"
            ],
            [
                62401,
                "MTN Cameroon"
            ],
            [
                62402,
                "Orange"
            ],
            [
                302290,
                "Airtel Wireless"
            ],
            [
                302652,
                "BC Tel Mobility"
            ],
            [
                302610,
                "Bell"
            ],
            [
                302640,
                "Bell"
            ],
            [
                302880,
                "Bell / Telus / SaskTel"
            ],
            [
                302651,
                "Bell Mobility"
            ],
            [
                302380,
                "DMTS"
            ],
            [
                302370,
                "Fido"
            ],
            [
                302350,
                "FIRST"
            ],
            [
                302710,
                "Globalstar"
            ],
            [
                302620,
                "ICE Wireless"
            ],
            [
                302701,
                "MB Tel Mobility"
            ],
            [
                302320,
                "Mobilicity"
            ],
            [
                302702,
                "MT&T Mobility"
            ],
            [
                302660,
                "MTS"
            ],
            [
                302655,
                "MTS Mobility"
            ],
            [
                302703,
                "New Tel Mobility"
            ],
            [
                302720,
                "Rogers Wireless"
            ],
            [
                302654,
                "Sask Tel Mobility"
            ],
            [
                302680,
                "SaskTel"
            ],
            [
                302780,
                "SaskTel"
            ],
            [
                302656,
                "Tbay Mobility"
            ],
            [
                302220,
                "Telus"
            ],
            [
                302221,
                "Telus"
            ],
            [
                302657,
                "Telus (Quebec) Mobility"
            ],
            [
                302360,
                "Telus Mobility"
            ],
            [
                302361,
                "Telus Mobility"
            ],
            [
                302653,
                "Telus Mobility"
            ],
            [
                302500,
                "Videotron"
            ],
            [
                302510,
                "Videotron"
            ],
            [
                302490,
                "WIND Mobile"
            ],
            [
                62501,
                "CVMOVEL"
            ],
            [
                62502,
                "T+"
            ],
            [
                346140,
                "Cable & Wireless"
            ],
            [
                346050,
                "Digicel"
            ],
            [
                62301,
                "CTP"
            ],
            [
                62304,
                "Nationlink"
            ],
            [
                62303,
                "Orange"
            ],
            [
                62302,
                "TC"
            ],
            [
                73003,
                "Claro"
            ],
            [
                73001,
                "Entel"
            ],
            [
                73010,
                "Entel"
            ],
            [
                73002,
                "movistar"
            ],
            [
                73004,
                "Nextel"
            ],
            [
                73008,
                "VTR Móvil"
            ],
            [
                73099,
                "Will"
            ],
            [
                46006,
                "(unknown)"
            ],
            [
                46000,
                "China Mobile"
            ],
            [
                46002,
                "China Mobile"
            ],
            [
                46007,
                "China Mobile"
            ],
            [
                46003,
                "China Telecom"
            ],
            [
                46005,
                "China Telecom"
            ],
            [
                46020,
                "China Tietong"
            ],
            [
                46001,
                "China Unicom"
            ],
            [
                732001,
                "Colombia Telecomunicaciones S.A. - Telecom"
            ],
            [
                732101,
                "Comcel"
            ],
            [
                732002,
                "Edatel"
            ],
            [
                732102,
                "movistar"
            ],
            [
                732123,
                "movistar"
            ],
            [
                732103,
                "Tigo"
            ],
            [
                732111,
                "Tigo"
            ],
            [
                65401,
                "HURI - SNPT"
            ],
            [
                54801,
                "Telecom Cook"
            ],
            [
                71201,
                "ICE"
            ],
            [
                71202,
                "ICE"
            ],
            [
                71203,
                "ICE"
            ],
            [
                71204,
                "movistar"
            ],
            [
                61201,
                "Cora de Comstar"
            ],
            [
                61204,
                "KoZ"
            ],
            [
                61202,
                "Moov"
            ],
            [
                61205,
                "MTN"
            ],
            [
                61203,
                "Orange"
            ],
            [
                61206,
                "ORICEL"
            ],
            [
                21901,
                "T-Mobile"
            ],
            [
                21902,
                "Tele2"
            ],
            [
                21910,
                "VIPnet"
            ],
            [
                36801,
                "ETECSA"
            ],
            [
                28001,
                "Cytamobile-Vodafone"
            ],
            [
                28010,
                "MTN"
            ],
            [
                62204,
                "Salam"
            ],
            [
                62202,
                "TAWALI"
            ],
            [
                62203,
                "TIGO - Millicom"
            ],
            [
                62201,
                "Zain"
            ],
            [
                23002,
                "EUROTEL PRAHA"
            ],
            [
                23003,
                "OSKAR"
            ],
            [
                23006,
                "OSNO TELECOMUNICATION, s.r.o."
            ],
            [
                23098,
                "SŽDC s.o."
            ],
            [
                23001,
                "T-Mobile"
            ],
            [
                23005,
                "TRAVEL TELEKOMMUNIKATION, s.r.o."
            ],
            [
                23004,
                "U:fon"
            ],
            [
                23099,
                "Vodafone Czech Republic a.s., R&D Centre at FEE, CTU"
            ],
            [
                63086,
                "CCT"
            ],
            [
                63004,
                "Cellco"
            ],
            [
                63010,
                "Libertis Telecom"
            ],
            [
                63089,
                "SAIT Telecom"
            ],
            [
                63005,
                "Supercell"
            ],
            [
                63001,
                "Vodacom"
            ],
            [
                63002,
                "Zain"
            ],
            [
                23806,
                "3"
            ],
            [
                23805,
                "ApS KBUS"
            ],
            [
                23807,
                "Barablu Mobile Ltd."
            ],
            [
                23809,
                "Dansk Beredskabskommunikation A/S"
            ],
            [
                23811,
                "Dansk Beredskabskommunikation A/S"
            ],
            [
                23840,
                "Ericsson Danmark A/S"
            ],
            [
                23812,
                "Lycamobile Denmark Ltd"
            ],
            [
                23803,
                "MIGway A/S"
            ],
            [
                23877,
                "Sonofon"
            ],
            [
                23801,
                "TDC"
            ],
            [
                23810,
                "TDC"
            ],
            [
                23802,
                "Telenor"
            ],
            [
                23866,
                "Telenor"
            ],
            [
                23820,
                "Telia"
            ],
            [
                23830,
                "Telia"
            ],
            [
                63801,
                "Evatis"
            ],
            [
                366110,
                "Cable & Wireless"
            ],
            [
                366020,
                "Digicel"
            ],
            [
                37002,
                "Claro"
            ],
            [
                37001,
                "Orange"
            ],
            [
                37003,
                "Tricom S.A."
            ],
            [
                37004,
                "ViVa"
            ],
            [
                51402,
                "Timor Telecom"
            ],
            [
                74002,
                "Alegro"
            ],
            [
                74000,
                "Movistar"
            ],
            [
                74001,
                "Porta"
            ],
            [
                60203,
                "Etisalat"
            ],
            [
                60201,
                "Mobinil"
            ],
            [
                60202,
                "Vodafone"
            ],
            [
                70610,
                "Claro"
            ],
            [
                70611,
                "Claro"
            ],
            [
                70601,
                "CTE Telecom Personal"
            ],
            [
                70602,
                "digicel"
            ],
            [
                70604,
                "movistar"
            ],
            [
                70603,
                "Telemovil EL Salvador"
            ],
            [
                62703,
                "Hits GQ"
            ],
            [
                62701,
                "Orange GQ"
            ],
            [
                65701,
                "Eritel"
            ],
            [
                24805,
                "AS Bravocom Mobiil"
            ],
            [
                24802,
                "Elisa"
            ],
            [
                24801,
                "EMT"
            ],
            [
                24804,
                "OY Top Connect"
            ],
            [
                24806,
                "OY ViaTel"
            ],
            [
                24803,
                "Tele 2"
            ],
            [
                63601,
                "ETMTN"
            ],
            [
                28801,
                "Faroese Telecom"
            ],
            [
                28802,
                "Vodafone"
            ],
            [
                54202,
                "Digicel"
            ],
            [
                54201,
                "Vodafone"
            ],
            [
                24414,
                "AMT"
            ],
            [
                24403,
                "DNA"
            ],
            [
                24412,
                "DNA"
            ],
            [
                24405,
                "Elisa"
            ],
            [
                24407,
                "Nokia"
            ],
            [
                24415,
                "SAMK"
            ],
            [
                24421,
                "Saunalahti"
            ],
            [
                24429,
                "Scnl Truphone"
            ],
            [
                24491,
                "Sonera"
            ],
            [
                24410,
                "TDC Oy"
            ],
            [
                24408,
                "Unknown"
            ],
            [
                24411,
                "VIRVE"
            ],
            [
                20820,
                "Bouygues"
            ],
            [
                20821,
                "Bouygues"
            ],
            [
                20888,
                "Bouygues"
            ],
            [
                20801,
                "Orange"
            ],
            [
                20814,
                "Free Mobile"
            ],
            [
                20815,
                "Free Mobile"
            ],
            [
                20805,
                "Globalstar Europe"
            ],
            [
                20806,
                "Globalstar Europe"
            ],
            [
                20807,
                "Globalstar Europe"
            ],
            [
                20800,
                "Orange"
            ],
            [
                20802,
                "Orange"
            ],
            [
                20810,
                "SFR"
            ],
            [
                20811,
                "SFR"
            ],
            [
                20813,
                "SFR"
            ],
            [
                20822,
                "Transatel Mobile"
            ],
            [
                null,
                "Virgin"
            ],
            [
                54720,
                "VINI"
            ],
            [
                62804,
                "Azur"
            ],
            [
                62801,
                "Libertis"
            ],
            [
                62802,
                "Moov (Telecel) Gabon S.A."
            ],
            [
                62803,
                "Zain"
            ],
            [
                60702,
                "Africel"
            ],
            [
                60703,
                "Comium"
            ],
            [
                60701,
                "Gamcel"
            ],
            [
                60704,
                "QCell"
            ],
            [
                28988,
                "A-Mobile"
            ],
            [
                28967,
                "Aquafon"
            ],
            [
                28204,
                "Beeline"
            ],
            [
                28201,
                "Geocell"
            ],
            [
                28203,
                "Iberiatel"
            ],
            [
                28202,
                "Magti"
            ],
            [
                28205,
                "Silknet"
            ],
            [
                26242,
                "27C3"
            ],
            [
                26215,
                "Airdata"
            ],
            [
                26210,
                "Arcor AG & Co"
            ],
            [
                26260,
                "DB Telematik"
            ],
            [
                262901,
                "Debitel"
            ],
            [
                26212,
                "Dolphin Telecom"
            ],
            [
                26203,
                "E-Plus"
            ],
            [
                26205,
                "E-Plus"
            ],
            [
                26277,
                "E-Plus"
            ],
            [
                26214,
                "Group 3G UMTS"
            ],
            [
                26243,
                "LYCA"
            ],
            [
                26213,
                "Mobilcom Multimedia"
            ],
            [
                26292,
                "Nash Technologies"
            ],
            [
                26207,
                "O2"
            ],
            [
                26208,
                "O2"
            ],
            [
                26211,
                "O2"
            ],
            [
                26276,
                "Siemens AG"
            ],
            [
                26201,
                "T-Mobile"
            ],
            [
                26206,
                "T-Mobile"
            ],
            [
                26216,
                "vistream"
            ],
            [
                26202,
                "Vodafone"
            ],
            [
                26204,
                "Vodafone"
            ],
            [
                26209,
                "Vodafone"
            ],
            [
                62006,
                "Airtel"
            ],
            [
                62002,
                "Ghana Telecom Mobile"
            ],
            [
                62004,
                "Kasapa / Hutchison Telecom"
            ],
            [
                62001,
                "MTN"
            ],
            [
                62003,
                "tiGO"
            ],
            [
                26606,
                "CTS Mobile"
            ],
            [
                26601,
                "GibTel"
            ],
            [
                20201,
                "Cosmote"
            ],
            [
                20205,
                "Vodafone"
            ],
            [
                20209,
                "Wind"
            ],
            [
                20210,
                "Wind"
            ],
            [
                29001,
                "TELE Greenland A/S"
            ],
            [
                352110,
                "Cable & Wireless"
            ],
            [
                352030,
                "Digicel"
            ],
            [
                34020,
                "Digicel"
            ],
            [
                34008,
                "MIO GSM"
            ],
            [
                34001,
                "Orange"
            ],
            [
                34002,
                "Outremer"
            ],
            [
                34003,
                "Telcell"
            ],
            [
                310033,
                "Guam Telephone Authority"
            ],
            [
                310370,
                "Guamcell"
            ],
            [
                310470,
                "Guamcell"
            ],
            [
                311250,
                "i CAN_GSM"
            ],
            [
                310032,
                "IT&E Wireless"
            ],
            [
                310140,
                "mPulse"
            ],
            [
                70401,
                "Claro"
            ],
            [
                70402,
                "Comcel / Tigo"
            ],
            [
                70403,
                "movistar"
            ],
            [
                73801,
                "Digicel"
            ],
            [
                73802,
                "GT&T Cellink Plus"
            ],
            [
                61105,
                "Cellcom"
            ],
            [
                61102,
                "Lagui"
            ],
            [
                61104,
                "MTN"
            ],
            [
                61101,
                "Spacetel"
            ],
            [
                61103,
                "Telecel Guinee"
            ],
            [
                63202,
                "Areeba"
            ],
            [
                63203,
                "Orange"
            ],
            [
                372010,
                "Comcel / Voila"
            ],
            [
                37202,
                "Digicel"
            ],
            [
                37203,
                "NATCOM"
            ],
            [
                20414,
                "6Gmobile"
            ],
            [
                20423,
                "ASPIDER Solutions Nederland B.V."
            ],
            [
                20427,
                "Breezz Nederland B.V."
            ],
            [
                20425,
                "CapX B.V."
            ],
            [
                20407,
                "eleena (MVNE)"
            ],
            [
                20405,
                "Elephant Talk Communications Premium Rate Services"
            ],
            [
                20417,
                "Intercity Mobile Communications B.V."
            ],
            [
                20408,
                "KPN"
            ],
            [
                20410,
                "KPN"
            ],
            [
                20469,
                "KPN Mobile The Netherlands B.V."
            ],
            [
                20409,
                "Lycamobile"
            ],
            [
                20422,
                "Ministerie van Defensie"
            ],
            [
                20419,
                "Mixe Communication Solutions B.V."
            ],
            [
                20406,
                "Mundio Mobile (Netherlands) Ltd"
            ],
            [
                20421,
                "NS Railinfrabeheer B.V."
            ],
            [
                20420,
                "Orange Nederland"
            ],
            [
                20424,
                "Private Mobility Nederland B.V."
            ],
            [
                20467,
                "RadioAccess B.V."
            ],
            [
                20426,
                "SpeakUp B.V."
            ],
            [
                20416,
                "T-Mobile / Ben"
            ],
            [
                20402,
                "Tele2 Netherlands"
            ],
            [
                20412,
                "Telfort / O2"
            ],
            [
                20413,
                "Unica Installatietechniek B.V"
            ],
            [
                20468,
                "Unify Group Holding B.V."
            ],
            [
                20418,
                "UPC Nederland B.V."
            ],
            [
                20401,
                "VastMobiel B.V."
            ],
            [
                20404,
                "Vodafone"
            ],
            [
                20403,
                "Voiceworks B.V."
            ],
            [
                70802,
                "Celtel / Tigo"
            ],
            [
                70801,
                "Claro"
            ],
            [
                70840,
                "DIGICEL"
            ],
            [
                70830,
                "Hondutel"
            ],
            [
                45403,
                "3 (3G)"
            ],
            [
                45405,
                "3 CDMA"
            ],
            [
                45404,
                "3 Dual (2G)"
            ],
            [
                45412,
                "C Peoples"
            ],
            [
                45409,
                "China Motion Telecom"
            ],
            [
                45407,
                "China Unicom"
            ],
            [
                45411,
                "China-Hongkong Telecom"
            ],
            [
                45401,
                "CITIC Telecom 1616"
            ],
            [
                45400,
                "CSL"
            ],
            [
                45402,
                "CSL 3G"
            ],
            [
                45418,
                "Hong Kong CSL Limited"
            ],
            [
                45414,
                "Hutchison Telecom"
            ],
            [
                45410,
                "New World"
            ],
            [
                45416,
                "PCCW"
            ],
            [
                45419,
                "PCCW"
            ],
            [
                45429,
                "PCCW"
            ],
            [
                45415,
                "SmarTone Mobile Comms"
            ],
            [
                45417,
                "SmarTone Mobile Comms"
            ],
            [
                45406,
                "Smartone-Vodafone"
            ],
            [
                45408,
                "Trident"
            ],
            [
                21601,
                "Pannon"
            ],
            [
                21630,
                "T-Mobile"
            ],
            [
                21670,
                "Vodafone"
            ],
            [
                27407,
                "IceCell"
            ],
            [
                27411,
                "Nova"
            ],
            [
                27406,
                "Núll níu ehf"
            ],
            [
                27408,
                "On-waves"
            ],
            [
                27401,
                "Siminn"
            ],
            [
                27412,
                "Tal"
            ],
            [
                27404,
                "Viking"
            ],
            [
                27402,
                "Vodafone"
            ],
            [
                27403,
                "Vodafone"
            ],
            [
                40417,
                "AIRCEL"
            ],
            [
                40425,
                "AIRCEL"
            ],
            [
                40428,
                "AIRCEL"
            ],
            [
                40429,
                "AIRCEL"
            ],
            [
                40437,
                "AIRCEL"
            ],
            [
                40491,
                "AIRCEL"
            ],
            [
                405082,
                "AIRCEL"
            ],
            [
                405800,
                "AIRCEL"
            ],
            [
                405801,
                "AIRCEL"
            ],
            [
                405802,
                "AIRCEL"
            ],
            [
                405803,
                "AIRCEL"
            ],
            [
                405804,
                "AIRCEL"
            ],
            [
                405805,
                "AIRCEL"
            ],
            [
                405806,
                "AIRCEL"
            ],
            [
                405807,
                "AIRCEL"
            ],
            [
                405808,
                "AIRCEL"
            ],
            [
                405809,
                "AIRCEL"
            ],
            [
                405810,
                "AIRCEL"
            ],
            [
                405811,
                "AIRCEL"
            ],
            [
                405812,
                "AIRCEL"
            ],
            [
                405813,
                "AIRCEL"
            ],
            [
                40460,
                "Aircell Digilink"
            ],
            [
                40415,
                "Aircell Digilink Essar Cellph."
            ],
            [
                40406,
                "Airtel"
            ],
            [
                40410,
                "Airtel"
            ],
            [
                40431,
                "Airtel"
            ],
            [
                40440,
                "Airtel"
            ],
            [
                40445,
                "Airtel"
            ],
            [
                40449,
                "Airtel"
            ],
            [
                40470,
                "Airtel"
            ],
            [
                40494,
                "Airtel"
            ],
            [
                40495,
                "Airtel"
            ],
            [
                40497,
                "Airtel"
            ],
            [
                40498,
                "Airtel"
            ],
            [
                40551,
                "Airtel"
            ],
            [
                40552,
                "Airtel"
            ],
            [
                40553,
                "AirTel"
            ],
            [
                40554,
                "AirTel"
            ],
            [
                40555,
                "AirTel"
            ],
            [
                40556,
                "AirTel"
            ],
            [
                40570,
                "AirTel"
            ],
            [
                40496,
                "Airtel - Haryana"
            ],
            [
                40402,
                "Airtel - Punjab"
            ],
            [
                40403,
                "Airtel / Bharti Telenet"
            ],
            [
                40493,
                "Airtel Gujrat"
            ],
            [
                40490,
                "Airtel Maharashtra & Goa"
            ],
            [
                40492,
                "Airtel Mumbai"
            ],
            [
                40443,
                "BPL Mobile Cellular"
            ],
            [
                40421,
                "BPL Mobile Mumbai"
            ],
            [
                40427,
                "BPL USWest Cellular / Cellular Comms"
            ],
            [
                40434,
                "BSNL"
            ],
            [
                40438,
                "BSNL"
            ],
            [
                40451,
                "BSNL"
            ],
            [
                40453,
                "BSNL"
            ],
            [
                40454,
                "BSNL"
            ],
            [
                40455,
                "BSNL"
            ],
            [
                40457,
                "BSNL"
            ],
            [
                40458,
                "BSNL"
            ],
            [
                40459,
                "BSNL"
            ],
            [
                40464,
                "BSNL"
            ],
            [
                40471,
                "BSNL"
            ],
            [
                40473,
                "BSNL"
            ],
            [
                40474,
                "BSNL"
            ],
            [
                40475,
                "BSNL"
            ],
            [
                40476,
                "BSNL"
            ],
            [
                40477,
                "BSNL"
            ],
            [
                40480,
                "BSNL"
            ],
            [
                40481,
                "BSNL"
            ],
            [
                40462,
                "BSNL J&K"
            ],
            [
                40472,
                "BSNL Kerala"
            ],
            [
                40466,
                "BSNL Maharashtra & Goa"
            ],
            [
                40478,
                "BTA Cellcom"
            ],
            [
                40448,
                "Dishnet Wireless"
            ],
            [
                40482,
                "Escorts"
            ],
            [
                40487,
                "Escorts Telecom"
            ],
            [
                40488,
                "Escorts Telecom"
            ],
            [
                40489,
                "Escorts Telecom"
            ],
            [
                40411,
                "Essar / Sterling Cellular"
            ],
            [
                405912,
                "Etisalat DB(cheers)"
            ],
            [
                405913,
                "Etisalat DB(cheers)"
            ],
            [
                405914,
                "Etisalat DB(cheers)"
            ],
            [
                405917,
                "Etisalat DB(cheers)"
            ],
            [
                40566,
                "Hutch"
            ],
            [
                40486,
                "Hutchinson Essar South"
            ],
            [
                40413,
                "Hutchison Essar South"
            ],
            [
                40484,
                "Hutchison Essar South"
            ],
            [
                40419,
                "IDEA"
            ],
            [
                405799,
                "IDEA"
            ],
            [
                405845,
                "IDEA"
            ],
            [
                405848,
                "IDEA"
            ],
            [
                405850,
                "IDEA"
            ],
            [
                40586,
                "IDEA"
            ],
            [
                40412,
                "Idea (Escotel) Haryana"
            ],
            [
                40456,
                "Idea (Escotel) UP West"
            ],
            [
                40404,
                "IDEA CELLULAR - Delhi"
            ],
            [
                40424,
                "IDEA Cellular - Gujarat"
            ],
            [
                40422,
                "IDEA Cellular - Maharashtra"
            ],
            [
                405855,
                "Loop Mobile"
            ],
            [
                405864,
                "Loop Mobile"
            ],
            [
                405865,
                "Loop Mobile"
            ],
            [
                40468,
                "MTNL - Delhi"
            ],
            [
                40469,
                "MTNL - Mumbai"
            ],
            [
                40450,
                "Reliance"
            ],
            [
                40452,
                "Reliance"
            ],
            [
                40467,
                "Reliance"
            ],
            [
                40483,
                "Reliance"
            ],
            [
                40485,
                "Reliance"
            ],
            [
                40501,
                "Reliance"
            ],
            [
                40503,
                "Reliance"
            ],
            [
                40504,
                "Reliance"
            ],
            [
                40509,
                "Reliance"
            ],
            [
                40510,
                "Reliance"
            ],
            [
                40513,
                "Reliance"
            ],
            [
                40409,
                "Reliance Telecom Private"
            ],
            [
                40436,
                "Reliance Telecom Private"
            ],
            [
                40441,
                "RPG MAA"
            ],
            [
                405881,
                "S Tel"
            ],
            [
                40444,
                "Spice Telecom - Karnataka"
            ],
            [
                40414,
                "Spice Telecom - Punjab"
            ],
            [
                40442,
                "Srinivas Cellcom / Aircel"
            ],
            [
                40407,
                "TATA Cellular / Idea Cellular"
            ],
            [
                405025,
                "TATA Teleservice"
            ],
            [
                405026,
                "TATA Teleservice"
            ],
            [
                405027,
                "TATA Teleservice"
            ],
            [
                405029,
                "TATA Teleservice"
            ],
            [
                405030,
                "TATA Teleservice"
            ],
            [
                405031,
                "TATA Teleservice"
            ],
            [
                405032,
                "TATA Teleservice"
            ],
            [
                405033,
                "TATA Teleservice"
            ],
            [
                405034,
                "TATA Teleservice"
            ],
            [
                405035,
                "TATA Teleservice"
            ],
            [
                405036,
                "TATA Teleservice"
            ],
            [
                405037,
                "TATA Teleservice"
            ],
            [
                405038,
                "TATA Teleservice"
            ],
            [
                405039,
                "TATA Teleservice"
            ],
            [
                405040,
                "TATA Teleservice"
            ],
            [
                405041,
                "TATA Teleservice"
            ],
            [
                405042,
                "TATA Teleservice"
            ],
            [
                405043,
                "TATA Teleservice"
            ],
            [
                405044,
                "TATA Teleservice"
            ],
            [
                405045,
                "TATA Teleservice"
            ],
            [
                405046,
                "TATA Teleservice"
            ],
            [
                405047,
                "TATA Teleservice"
            ],
            [
                405818,
                "Uninor"
            ],
            [
                405819,
                "Uninor"
            ],
            [
                405820,
                "Uninor"
            ],
            [
                405821,
                "Uninor"
            ],
            [
                405822,
                "Uninor"
            ],
            [
                405844,
                "Uninor"
            ],
            [
                405875,
                "Uninor"
            ],
            [
                405880,
                "Uninor"
            ],
            [
                405927,
                "Uninor"
            ],
            [
                405929,
                "Uninor"
            ],
            [
                405824,
                "Videocon Datacom"
            ],
            [
                405827,
                "Videocon Datacom"
            ],
            [
                405834,
                "Videocon Datacom"
            ],
            [
                40420,
                "Vodafone"
            ],
            [
                40446,
                "Vodafone"
            ],
            [
                40405,
                "Vodafone - Gujarat"
            ],
            [
                40401,
                "Vodafone - Haryana"
            ],
            [
                40430,
                "Vodafone - Kolkata"
            ],
            [
                405750,
                "Vodafone IN"
            ],
            [
                405751,
                "Vodafone IN"
            ],
            [
                405752,
                "Vodafone IN"
            ],
            [
                405753,
                "Vodafone IN"
            ],
            [
                405754,
                "Vodafone IN"
            ],
            [
                405755,
                "Vodafone IN"
            ],
            [
                405756,
                "Vodafone IN"
            ],
            [
                51089,
                "3"
            ],
            [
                51008,
                "AXIS"
            ],
            [
                null,
                "Ceria"
            ],
            [
                51027,
                "Ceria"
            ],
            [
                51099,
                "Esia"
            ],
            [
                51028,
                "Fren/Hepi"
            ],
            [
                51021,
                "IM3"
            ],
            [
                51001,
                "INDOSAT"
            ],
            [
                51000,
                "PSN"
            ],
            [
                51009,
                "SMART"
            ],
            [
                51003,
                "StarOne"
            ],
            [
                51007,
                "TelkomFlexi"
            ],
            [
                51020,
                "TELKOMMobile"
            ],
            [
                51010,
                "Telkomsel"
            ],
            [
                51011,
                "XL"
            ],
            [
                43235,
                "Irancell"
            ],
            [
                43293,
                "Iraphone"
            ],
            [
                43211,
                "MCI"
            ],
            [
                43219,
                "MTCE"
            ],
            [
                43232,
                "Taliya"
            ],
            [
                43270,
                "TCI"
            ],
            [
                43214,
                "TKC"
            ],
            [
                41805,
                "Asia Cell"
            ],
            [
                41850,
                "Asia Cell"
            ],
            [
                41840,
                "Korek"
            ],
            [
                41845,
                "Mobitel"
            ],
            [
                41892,
                "Omnnea"
            ],
            [
                41808,
                "SanaTel"
            ],
            [
                41820,
                "Zain IQ"
            ],
            [
                41830,
                "Zain IQ"
            ],
            [
                27205,
                "3"
            ],
            [
                27204,
                "Access Telecom"
            ],
            [
                27209,
                "Clever Communications"
            ],
            [
                27200,
                "E-Mobile"
            ],
            [
                27207,
                "Eircom"
            ],
            [
                27211,
                "Liffey Telecom"
            ],
            [
                27203,
                "Meteor"
            ],
            [
                27202,
                "O2"
            ],
            [
                272020,
                "Tesco Mobile"
            ],
            [
                27201,
                "Vodafone"
            ],
            [
                42502,
                "Cellcom"
            ],
            [
                42577,
                "Mirs"
            ],
            [
                42501,
                "Orange"
            ],
            [
                null,
                "Partner"
            ],
            [
                42503,
                "Pelephone"
            ],
            [
                22299,
                "3 Italia"
            ],
            [
                22298,
                "Blu"
            ],
            [
                22202,
                "Elsacom"
            ],
            [
                22277,
                "IPSE 2000"
            ],
            [
                22207,
                "Noverca"
            ],
            [
                22230,
                "RFI"
            ],
            [
                22201,
                "TIM"
            ],
            [
                22210,
                "Vodafone"
            ],
            [
                22288,
                "Wind"
            ],
            [
                338020,
                "Cable & Wireless"
            ],
            [
                338180,
                "Cable & Wireless"
            ],
            [
                338070,
                "Claro"
            ],
            [
                338050,
                "Digicel"
            ],
            [
                44001,
                "DoCoMo"
            ],
            [
                44002,
                "DoCoMo"
            ],
            [
                44003,
                "DoCoMo"
            ],
            [
                44009,
                "DoCoMo"
            ],
            [
                44010,
                "DoCoMo"
            ],
            [
                44011,
                "DoCoMo"
            ],
            [
                44012,
                "DoCoMo"
            ],
            [
                44013,
                "DoCoMo"
            ],
            [
                44014,
                "DoCoMo"
            ],
            [
                44015,
                "DoCoMo"
            ],
            [
                44016,
                "DoCoMo"
            ],
            [
                44017,
                "DoCoMo"
            ],
            [
                44018,
                "DoCoMo"
            ],
            [
                44019,
                "DoCoMo"
            ],
            [
                44021,
                "DoCoMo"
            ],
            [
                44022,
                "DoCoMo"
            ],
            [
                44023,
                "DoCoMo"
            ],
            [
                44024,
                "DoCoMo"
            ],
            [
                44025,
                "DoCoMo"
            ],
            [
                44026,
                "DoCoMo"
            ],
            [
                44027,
                "DoCoMo"
            ],
            [
                44028,
                "DoCoMo"
            ],
            [
                44029,
                "DoCoMo"
            ],
            [
                44030,
                "DoCoMo"
            ],
            [
                44031,
                "DoCoMo"
            ],
            [
                44032,
                "DoCoMo"
            ],
            [
                44033,
                "DoCoMo"
            ],
            [
                44034,
                "DoCoMo"
            ],
            [
                44035,
                "DoCoMo"
            ],
            [
                44036,
                "DoCoMo"
            ],
            [
                44037,
                "DoCoMo"
            ],
            [
                44038,
                "DoCoMo"
            ],
            [
                44039,
                "DoCoMo"
            ],
            [
                44049,
                "DoCoMo"
            ],
            [
                44058,
                "DoCoMo"
            ],
            [
                44060,
                "DoCoMo"
            ],
            [
                44061,
                "DoCoMo"
            ],
            [
                44062,
                "DoCoMo"
            ],
            [
                44063,
                "DoCoMo"
            ],
            [
                44064,
                "DoCoMo"
            ],
            [
                44065,
                "DoCoMo"
            ],
            [
                44066,
                "DoCoMo"
            ],
            [
                44067,
                "DoCoMo"
            ],
            [
                44068,
                "DoCoMo"
            ],
            [
                44069,
                "DoCoMo"
            ],
            [
                44087,
                "DoCoMo"
            ],
            [
                44099,
                "DoCoMo"
            ],
            [
                44000,
                "eMobile"
            ],
            [
                44007,
                "KDDI"
            ],
            [
                44008,
                "KDDI"
            ],
            [
                44050,
                "KDDI"
            ],
            [
                44051,
                "KDDI"
            ],
            [
                44052,
                "KDDI"
            ],
            [
                44053,
                "KDDI"
            ],
            [
                44054,
                "KDDI"
            ],
            [
                44055,
                "KDDI"
            ],
            [
                44056,
                "KDDI"
            ],
            [
                44070,
                "KDDI"
            ],
            [
                44071,
                "KDDI"
            ],
            [
                44072,
                "KDDI"
            ],
            [
                44073,
                "KDDI"
            ],
            [
                44074,
                "KDDI"
            ],
            [
                44075,
                "KDDI"
            ],
            [
                44076,
                "KDDI"
            ],
            [
                44077,
                "KDDI"
            ],
            [
                44079,
                "KDDI"
            ],
            [
                44088,
                "KDDI"
            ],
            [
                44089,
                "KDDI"
            ],
            [
                44078,
                "Okinawa Cellular Telephone"
            ],
            [
                44020,
                "SoftBank"
            ],
            [
                44080,
                "TU-KA"
            ],
            [
                44081,
                "TU-KA"
            ],
            [
                44082,
                "TU-KA"
            ],
            [
                44083,
                "TU-KA"
            ],
            [
                44084,
                "TU-KA"
            ],
            [
                44085,
                "TU-KA"
            ],
            [
                44086,
                "TU-KA"
            ],
            [
                44004,
                "Vodafone"
            ],
            [
                44006,
                "Vodafone"
            ],
            [
                44040,
                "Vodafone"
            ],
            [
                44041,
                "Vodafone"
            ],
            [
                44042,
                "Vodafone"
            ],
            [
                44043,
                "Vodafone"
            ],
            [
                44044,
                "Vodafone"
            ],
            [
                44045,
                "Vodafone"
            ],
            [
                44046,
                "Vodafone"
            ],
            [
                44047,
                "Vodafone"
            ],
            [
                44048,
                "Vodafone"
            ],
            [
                44090,
                "Vodafone"
            ],
            [
                44092,
                "Vodafone"
            ],
            [
                44093,
                "Vodafone"
            ],
            [
                44094,
                "Vodafone"
            ],
            [
                44095,
                "Vodafone"
            ],
            [
                44096,
                "Vodafone"
            ],
            [
                44097,
                "Vodafone"
            ],
            [
                44098,
                "Vodafone"
            ],
            [
                41677,
                "Orange"
            ],
            [
                41603,
                "Umniah"
            ],
            [
                41602,
                "XPress Telecom"
            ],
            [
                41601,
                "Zain"
            ],
            [
                40101,
                "Beeline"
            ],
            [
                40107,
                "Dalacom"
            ],
            [
                40102,
                "K'Cell"
            ],
            [
                40108,
                "Kazakhtelecom"
            ],
            [
                40177,
                "Mobile Telecom Service"
            ],
            [
                63907,
                "Orange Kenya"
            ],
            [
                63902,
                "Safaricom"
            ],
            [
                63905,
                "yu"
            ],
            [
                63903,
                "Zain"
            ],
            [
                54509,
                "Kiribati Frigate"
            ],
            [
                41904,
                "Viva"
            ],
            [
                41903,
                "Wataniya"
            ],
            [
                41902,
                "Zain"
            ],
            [
                43701,
                "Bitel"
            ],
            [
                43703,
                "Fonex"
            ],
            [
                43705,
                "MegaCom"
            ],
            [
                43709,
                "O!"
            ],
            [
                45702,
                "ETL"
            ],
            [
                45701,
                "LaoTel"
            ],
            [
                45703,
                "LAT"
            ],
            [
                45708,
                "Tigo"
            ],
            [
                24705,
                "Bite"
            ],
            [
                24709,
                "Camel Mobile"
            ],
            [
                24708,
                "IZZI"
            ],
            [
                24701,
                "LMT"
            ],
            [
                24707,
                "MTS"
            ],
            [
                24706,
                "Rigatta"
            ],
            [
                24702,
                "Tele2"
            ],
            [
                24703,
                "TRIATEL"
            ],
            [
                41501,
                "Alfa"
            ],
            [
                41503,
                "MTC-Touch"
            ],
            [
                41505,
                "Ogero Mobile"
            ],
            [
                65102,
                "Econet Ezin-cel"
            ],
            [
                65101,
                "Vodacom"
            ],
            [
                60602,
                "Al-Jeel Phone"
            ],
            [
                60606,
                "Hatef Libya"
            ],
            [
                60603,
                "Libya Phone"
            ],
            [
                60600,
                "Libyana"
            ],
            [
                60601,
                "Madar"
            ],
            [
                29504,
                "Cubic Telecom"
            ],
            [
                29505,
                "FL1"
            ],
            [
                29502,
                "Orange"
            ],
            [
                29501,
                "Swisscom"
            ],
            [
                29577,
                "Tele 2"
            ],
            [
                24602,
                "BITE"
            ],
            [
                24605,
                "LitRail"
            ],
            [
                24606,
                "Mediafon"
            ],
            [
                24601,
                "Omnitel"
            ],
            [
                24603,
                "Tele 2"
            ],
            [
                61807,
                "Cellcom"
            ],
            [
                61804,
                "Comium Liberi"
            ],
            [
                61802,
                "Libercell"
            ],
            [
                61820,
                "LIBTELCO"
            ],
            [
                61801,
                "Lonestar Cell"
            ],
            [
                27001,
                "LuxGSM"
            ],
            [
                27077,
                "Tango"
            ],
            [
                27099,
                "Voxmobile"
            ],
            [
                45503,
                "3"
            ],
            [
                45505,
                "3"
            ],
            [
                45502,
                "China Telecom"
            ],
            [
                45501,
                "CTM"
            ],
            [
                45504,
                "CTM"
            ],
            [
                45500,
                "SmarTone"
            ],
            [
                64602,
                "Orange"
            ],
            [
                64603,
                "Sacel"
            ],
            [
                64604,
                "Telma"
            ],
            [
                64601,
                "Zain"
            ],
            [
                65001,
                "TNM"
            ],
            [
                65010,
                "Zain"
            ],
            [
                50201,
                "ATUR 450"
            ],
            [
                502151,
                "Baraka Telecom Sdn Bhd (MVNE)"
            ],
            [
                50213,
                "Celcom"
            ],
            [
                50219,
                "Celcom"
            ],
            [
                50216,
                "DiGi"
            ],
            [
                50210,
                "DiGi Telecommunications"
            ],
            [
                50220,
                "Electcoms Wireless Sdn Bhd"
            ],
            [
                50212,
                "Maxis"
            ],
            [
                50217,
                "Maxis"
            ],
            [
                50214,
                "Telekom Malaysia Berhad for PSTN SMS"
            ],
            [
                50211,
                "TM Homeline"
            ],
            [
                502150,
                "Tune Talk Sdn Bhd"
            ],
            [
                50218,
                "U Mobile"
            ],
            [
                502152,
                "Yes"
            ],
            [
                47201,
                "Dhiraagu"
            ],
            [
                47202,
                "Wataniya"
            ],
            [
                61001,
                "Malitel"
            ],
            [
                61002,
                "Orange"
            ],
            [
                27821,
                "GO"
            ],
            [
                27877,
                "Melita"
            ],
            [
                27801,
                "Vodafone"
            ],
            [
                60902,
                "Chinguitel"
            ],
            [
                60901,
                "Mattel"
            ],
            [
                60910,
                "Mauritel"
            ],
            [
                61710,
                "Emtel"
            ],
            [
                61702,
                "Mahanagar Telephone (Mauritius) Ltd."
            ],
            [
                61701,
                "Orange"
            ],
            [
                334050,
                "Iusacell"
            ],
            [
                33403,
                "movistar"
            ],
            [
                334030,
                "movistar"
            ],
            [
                33401,
                "Nextel"
            ],
            [
                334010,
                "Nextel"
            ],
            [
                33402,
                "Telcel"
            ],
            [
                334020,
                "Telcel"
            ],
            [
                55001,
                "FSM Telecom"
            ],
            [
                25904,
                "Eventis"
            ],
            [
                25903,
                "IDC"
            ],
            [
                25902,
                "Moldcell"
            ],
            [
                25901,
                "Orange"
            ],
            [
                25905,
                "Unité"
            ],
            [
                25999,
                "Unité"
            ],
            [
                21201,
                "Office des Telephones"
            ],
            [
                42898,
                "G.Mobile"
            ],
            [
                42899,
                "MobiCom"
            ],
            [
                42891,
                "Skytel"
            ],
            [
                42888,
                "Unitel"
            ],
            [
                29703,
                "m:tel CG"
            ],
            [
                22004,
                "T-Mobile"
            ],
            [
                29702,
                "T-Mobile"
            ],
            [
                29704,
                "T-Mobile"
            ],
            [
                29701,
                "Telenor Montenegro"
            ],
            [
                60401,
                "IAM"
            ],
            [
                60405,
                "INWI"
            ],
            [
                60400,
                "Méditel"
            ],
            [
                64301,
                "mCel"
            ],
            [
                64304,
                "Vodacom"
            ],
            [
                41401,
                "MPT"
            ],
            [
                64903,
                "Cell One"
            ],
            [
                64901,
                "MTC"
            ],
            [
                64902,
                "switch"
            ],
            [
                53602,
                "Digicel"
            ],
            [
                42902,
                "Mero Mobile"
            ],
            [
                42901,
                "Nepal Telecom"
            ],
            [
                42904,
                "SmartCell"
            ],
            [
                42903,
                "United Telecom Limited"
            ],
            [
                36294,
                "Bayòs"
            ],
            [
                36269,
                "Digicel"
            ],
            [
                36295,
                "MIO"
            ],
            [
                36251,
                "Telcell"
            ],
            [
                36291,
                "UTS"
            ],
            [
                54601,
                "Mobilis"
            ],
            [
                53024,
                "NZ Comms"
            ],
            [
                53000,
                "Telecom"
            ],
            [
                53002,
                "Telecom"
            ],
            [
                53005,
                "Telecom"
            ],
            [
                53004,
                "TelstraClear"
            ],
            [
                53001,
                "Vodafone"
            ],
            [
                53003,
                "Woosh"
            ],
            [
                53024,
                "Two Degrees Mobile"
            ],
            [
                71021,
                "Claro"
            ],
            [
                71030,
                "movistar"
            ],
            [
                71073,
                "SERCOM"
            ],
            [
                61404,
                "Orange"
            ],
            [
                61401,
                "SahelCom"
            ],
            [
                61403,
                "Telecel"
            ],
            [
                61402,
                "Zain"
            ],
            [
                62160,
                "Etisalat"
            ],
            [
                62150,
                "Glo"
            ],
            [
                62140,
                "M-Tel"
            ],
            [
                62130,
                "MTN"
            ],
            [
                62125,
                "Visafone"
            ],
            [
                62120,
                "Zain"
            ],
            [
                55501,
                "Telecom Niue"
            ],
            [
                467192,
                "Koryolink"
            ],
            [
                467193,
                "SUN NET"
            ],
            [
                24209,
                "Barablu Mobile Norway Ltd"
            ],
            [
                24206,
                "Ice"
            ],
            [
                24220,
                "Jernbaneverket AS"
            ],
            [
                24223,
                "Lyca"
            ],
            [
                24203,
                "MTU"
            ],
            [
                24202,
                "NetCom"
            ],
            [
                24205,
                "Network Norway"
            ],
            [
                24211,
                "SystemNet"
            ],
            [
                24208,
                "TDC Mobil AS"
            ],
            [
                24204,
                "Tele2"
            ],
            [
                24201,
                "Telenor"
            ],
            [
                null,
                "Telia"
            ],
            [
                24207,
                "Ventelo"
            ],
            [
                42203,
                "Nawras"
            ],
            [
                42202,
                "Oman Mobile"
            ],
            [
                25030,
                "Megafon"
            ],
            [
                41008,
                "Instaphone"
            ],
            [
                41001,
                "Mobilink"
            ],
            [
                41006,
                "Telenor"
            ],
            [
                41003,
                "Ufone"
            ],
            [
                41007,
                "Warid"
            ],
            [
                41004,
                "Zong"
            ],
            [
                55280,
                "Palau Mobile"
            ],
            [
                55201,
                "PNCC"
            ],
            [
                42505,
                "JAWWAL"
            ],
            [
                42506,
                "Wataniya"
            ],
            [
                71401,
                "Cable & Wireless"
            ],
            [
                71404,
                "Digicel"
            ],
            [
                71403,
                "laro"
            ],
            [
                71402,
                "movistar"
            ],
            [
                53701,
                "B-Mobile"
            ],
            [
                53703,
                "Digicel"
            ],
            [
                74402,
                "Claro"
            ],
            [
                74406,
                "Copaco"
            ],
            [
                74405,
                "Personal"
            ],
            [
                74404,
                "Tigo"
            ],
            [
                74401,
                "VOX"
            ],
            [
                71610,
                "Claro"
            ],
            [
                71606,
                "movistar"
            ],
            [
                71607,
                "NEXTEL"
            ],
            [
                51511,
                "ACeS Philippines"
            ],
            [
                51505,
                "Digitel"
            ],
            [
                51502,
                "Globe"
            ],
            [
                51501,
                "Islacom"
            ],
            [
                51588,
                "Nextel"
            ],
            [
                51518,
                "Red Mobile"
            ],
            [
                51503,
                "Smart Gold"
            ],
            [
                26017,
                "Aero2"
            ],
            [
                26015,
                "CenterNet"
            ],
            [
                26012,
                "Cyfrowy Polsat"
            ],
            [
                26008,
                "E-Telko"
            ],
            [
                26016,
                "Mobyland"
            ],
            [
                26011,
                "Nordisk Polska"
            ],
            [
                26003,
                "Orange"
            ],
            [
                26006,
                "Play"
            ],
            [
                26001,
                "Plus"
            ],
            [
                26005,
                "Polska Telefonia Komórkowa Centertel Sp. z o.o."
            ],
            [
                26007,
                "Premium Internet"
            ],
            [
                26013,
                "Sferia"
            ],
            [
                26002,
                "T-mobile"
            ],
            [
                26004,
                "Tele2"
            ],
            [
                26010,
                "Telefony Opalenickie"
            ],
            [
                26009,
                "Telekomunikacja Kolejowa"
            ],
            [
                26803,
                "Optimus"
            ],
            [
                26806,
                "TMN"
            ],
            [
                26801,
                "Vodafone"
            ],
            [
                26821,
                "Zapp"
            ],
            [
                33011,
                "Claro"
            ],
            [
                330110,
                "Claro"
            ],
            [
                33000,
                "Open Mobile"
            ],
            [
                42705,
                "Ministry of Interior"
            ],
            [
                42701,
                "Qatarnet"
            ],
            [
                42702,
                "Vodafone"
            ],
            [
                62910,
                "Libertis Telecom"
            ],
            [
                62907,
                "Warid Telecom"
            ],
            [
                62901,
                "Zain"
            ],
            [
                29402,
                "Cosmofon"
            ],
            [
                29401,
                "T-Mobile"
            ],
            [
                29403,
                "VIP"
            ],
            [
                64700,
                "Orange"
            ],
            [
                64702,
                "Outremer"
            ],
            [
                64710,
                "SFR Reunion"
            ],
            [
                22603,
                "Cosmote"
            ],
            [
                22605,
                "DIGI.mobil"
            ],
            [
                22611,
                "Enigma-System"
            ],
            [
                22610,
                "Orange"
            ],
            [
                22602,
                "Romtelecom"
            ],
            [
                22601,
                "Vodafone"
            ],
            [
                22604,
                "Zapp"
            ],
            [
                22606,
                "Zapp"
            ],
            [
                25012,
                "Baykalwestcom"
            ],
            [
                25028,
                "Beeline"
            ],
            [
                25099,
                "Beeline"
            ],
            [
                25010,
                "DTC"
            ],
            [
                25005,
                "ETK"
            ],
            [
                25019,
                "INDIGO"
            ],
            [
                25013,
                "KUGSM"
            ],
            [
                25002,
                "MegaFon"
            ],
            [
                25023,
                "Mobicom - Novosibirsk"
            ],
            [
                25035,
                "MOTIV"
            ],
            [
                25001,
                "MTS"
            ],
            [
                25003,
                "NCC"
            ],
            [
                25016,
                "NTC"
            ],
            [
                25011,
                "Orensot"
            ],
            [
                25092,
                "Primtelefon"
            ],
            [
                25004,
                "Sibchallenge"
            ],
            [
                25006,
                "Skylink"
            ],
            [
                25009,
                "Skylink"
            ],
            [
                25007,
                "SMARTS"
            ],
            [
                25014,
                "SMARTS"
            ],
            [
                25015,
                "SMARTS"
            ],
            [
                25044,
                "Stavtelesot / North Caucasian GSM"
            ],
            [
                25038,
                "Tambov GSM"
            ],
            [
                25020,
                "Tele2"
            ],
            [
                25093,
                "Telecom XXI"
            ],
            [
                25017,
                "Utel"
            ],
            [
                25039,
                "Utel"
            ],
            [
                63510,
                "MTN"
            ],
            [
                63512,
                "Rwandatel"
            ],
            [
                63513,
                "Tigo"
            ],
            [
                356110,
                "Cable & Wireless"
            ],
            [
                356070,
                "Chippie"
            ],
            [
                356050,
                "Digicel"
            ],
            [
                358110,
                "Cable & Wireless"
            ],
            [
                358050,
                "Digicel"
            ],
            [
                360110,
                "Cable & Wireless"
            ],
            [
                360100,
                "Cingular Wireless"
            ],
            [
                360050,
                "Digicel"
            ],
            [
                360070,
                "Digicel"
            ],
            [
                30801,
                "Ameris"
            ],
            [
                54901,
                "Digicel"
            ],
            [
                54927,
                "SamoaTel"
            ],
            [
                29201,
                "PRIMA"
            ],
            [
                62601,
                "CSTmovel"
            ],
            [
                42007,
                "EAE"
            ],
            [
                42003,
                "Mobily"
            ],
            [
                42001,
                "STC"
            ],
            [
                42004,
                "Zain SA"
            ],
            [
                60803,
                "Expresso"
            ],
            [
                60802,
                "Sentel GSM"
            ],
            [
                60801,
                "Sonatel ALIZE"
            ],
            [
                22003,
                "Telekom Srbija"
            ],
            [
                22001,
                "Telenor"
            ],
            [
                22005,
                "VIP Mobile"
            ],
            [
                63301,
                "Cable & Wireless (Seychelles) Ltd."
            ],
            [
                63302,
                "Mediatech International"
            ],
            [
                63310,
                "Telecom Airtel"
            ],
            [
                61905,
                "Africell"
            ],
            [
                61904,
                "Comium"
            ],
            [
                61903,
                "Datatel"
            ],
            [
                null,
                "Unknown"
            ],
            [
                61902,
                "Millicom"
            ],
            [
                61925,
                "Mobitel"
            ],
            [
                61901,
                "Zain"
            ],
            [
                52512,
                "Digital Trunked Radio Network"
            ],
            [
                52503,
                "M1"
            ],
            [
                52501,
                "SingTel"
            ],
            [
                52502,
                "SingTel-G18"
            ],
            [
                52505,
                "StarHub"
            ],
            [
                23105,
                "Mobile Entertainment Company"
            ],
            [
                23106,
                "O2"
            ],
            [
                23101,
                "Orange"
            ],
            [
                23102,
                "T-Mobile"
            ],
            [
                23104,
                "T-Mobile"
            ],
            [
                23103,
                "Unient Communications"
            ],
            [
                23199,
                "ŽSR"
            ],
            [
                29341,
                "Mobitel"
            ],
            [
                29340,
                "SI.mobil - Vodafone"
            ],
            [
                29364,
                "T-2"
            ],
            [
                29370,
                "Tusmobil"
            ],
            [
                54001,
                "BREEZE"
            ],
            [
                5401,
                "BREEZE"
            ],
            [
                63730,
                "Golis"
            ],
            [
                63725,
                "Hormuud"
            ],
            [
                63710,
                "Nationlink"
            ],
            [
                63760,
                "Nationlink Telecom"
            ],
            [
                63704,
                "Somafone"
            ],
            [
                638,
                "Telcom Mobile"
            ],
            [
                63701,
                "Telesom"
            ],
            [
                63782,
                "Telesom"
            ],
            [
                65530,
                "Bokamoso Consortium"
            ],
            [
                65521,
                "Cape Town Metropolitan Council"
            ],
            [
                65507,
                "Cell C"
            ],
            [
                65532,
                "Ilizwi Telecommunications"
            ],
            [
                65531,
                "Karabo Telecoms (Pty) Ltd."
            ],
            [
                65510,
                "MTN"
            ],
            [
                65513,
                "Neotel"
            ],
            [
                65511,
                "SAPS Gauteng"
            ],
            [
                65506,
                "Sentech"
            ],
            [
                65502,
                "Telkom Mobile / 8.ta"
            ],
            [
                65533,
                "Thinta Thinta Telecommunications"
            ],
            [
                65501,
                "Vodacom"
            ],
            [
                45004,
                "KT"
            ],
            [
                45008,
                "KTF"
            ],
            [
                45002,
                "KTF CDMA"
            ],
            [
                45006,
                "LGU+"
            ],
            [
                45003,
                "Power 017"
            ],
            [
                45005,
                "SK Telecom"
            ],
            [
                21423,
                "BARABLU MÓVIL ESPANA"
            ],
            [
                21415,
                "BT"
            ],
            [
                21422,
                "DigiMobil"
            ],
            [
                21424,
                "Eroski"
            ],
            [
                21408,
                "Euskaltel"
            ],
            [
                21420,
                "Fonyou"
            ],
            [
                21425,
                "LycaMobile"
            ],
            [
                21407,
                "movistar"
            ],
            [
                21417,
                "Móbil R"
            ],
            [
                21418,
                "ONO"
            ],
            [
                21403,
                "Orange"
            ],
            [
                21409,
                "Orange"
            ],
            [
                21419,
                "Simyo"
            ],
            [
                21416,
                "TeleCable"
            ],
            [
                21405,
                "TME"
            ],
            [
                21401,
                "Vodafone"
            ],
            [
                21406,
                "Vodafone"
            ],
            [
                21404,
                "Yoigo"
            ],
            [
                41305,
                "Airtel"
            ],
            [
                41302,
                "Dialog"
            ],
            [
                41308,
                "Hutch Sri Lanka"
            ],
            [
                41301,
                "Mobitel"
            ],
            [
                41303,
                "Tigo"
            ],
            [
                63401,
                "Mobitel / Mobile Telephone Company"
            ],
            [
                63403,
                "Gemtel"
            ],
            [
                63402,
                "MTN"
            ],
            [
                63407,
                "Sudani One"
            ],
            [
                63405,
                "Vivacell"
            ],
            [
                63406,
                "Zain"
            ],
            [
                74603,
                "Digicel"
            ],
            [
                74602,
                "Telesu"
            ],
            [
                74604,
                "Uniqa"
            ],
            [
                65310,
                "Swazi MTN"
            ],
            [
                24002,
                "3 HUTCHISON"
            ],
            [
                24004,
                "3G Infrastructure Services"
            ],
            [
                24016,
                "42IT"
            ],
            [
                24021,
                "Banverket"
            ],
            [
                24012,
                "Barablu Mobile Scandinavia"
            ],
            [
                24026,
                "Beepsend"
            ],
            [
                24025,
                "DigiTelMobile"
            ],
            [
                24017,
                "Gotanet"
            ],
            [
                24000,
                "Halebop"
            ],
            [
                24011,
                "Lindholmen Science Park"
            ],
            [
                24033,
                "Mobile Arts AB"
            ],
            [
                24003,
                "Nordisk Mobiltelefon"
            ],
            [
                24010,
                "SpringMobil"
            ],
            [
                24024,
                "Sweden 2G"
            ],
            [
                24024,
                "Sweden 2G"
            ],
            [
                24005,
                "Sweden 3G"
            ],
            [
                24014,
                "TDC Mobil"
            ],
            [
                24007,
                "Tele2Comviq"
            ],
            [
                24006,
                "Telenor"
            ],
            [
                24008,
                "Telenor"
            ],
            [
                24009,
                "Telenor"
            ],
            [
                24001,
                "Telia"
            ],
            [
                24013,
                "Ventelo Sverige"
            ],
            [
                24020,
                "Wireless Maingate"
            ],
            [
                24015,
                "Wireless Maingate Nordic"
            ],
            [
                22850,
                "3G Mobile AG"
            ],
            [
                22851,
                "BebbiCell AG"
            ],
            [
                22807,
                "IN&Phone"
            ],
            [
                22803,
                "Orange"
            ],
            [
                22806,
                "SBB AG"
            ],
            [
                22802,
                "Sunrise"
            ],
            [
                22801,
                "Swisscom"
            ],
            [
                22808,
                "Tele2"
            ],
            [
                22805,
                "Togewanet AG (Comfone)"
            ],
            [
                41702,
                "MTN Syria"
            ],
            [
                41701,
                "SyriaTel"
            ],
            [
                46602,
                "APTG"
            ],
            [
                46605,
                "APTG"
            ],
            [
                46611,
                "Chunghwa LDM"
            ],
            [
                46692,
                "Chungwa"
            ],
            [
                46601,
                "FarEasTone"
            ],
            [
                46688,
                "KG Telecom"
            ],
            [
                46693,
                "MobiTai"
            ],
            [
                46697,
                "Taiwan Mobile"
            ],
            [
                46699,
                "TransAsia"
            ],
            [
                46606,
                "Tuntex"
            ],
            [
                46689,
                "VIBO"
            ],
            [
                43604,
                "Babilon-M"
            ],
            [
                43605,
                "CTJTHSC Tajik-tel"
            ],
            [
                43602,
                "Indigo"
            ],
            [
                43603,
                "MLT"
            ],
            [
                43601,
                "Somoncom"
            ],
            [
                43612,
                "Tcell"
            ],
            [
                64009,
                "Hits"
            ],
            [
                64002,
                "Mobitel"
            ],
            [
                64006,
                "Sasatel"
            ],
            [
                64011,
                "SmileCom"
            ],
            [
                64001,
                "Tritel"
            ],
            [
                64007,
                "TTCL Mobile"
            ],
            [
                64008,
                "TTCL Mobile"
            ],
            [
                64004,
                "Vodacom"
            ],
            [
                64005,
                "Zain"
            ],
            [
                64003,
                "Zantel"
            ],
            [
                52015,
                "ACT Mobile"
            ],
            [
                52001,
                "Advanced Info Service"
            ],
            [
                52023,
                "Advanced Info Service"
            ],
            [
                52000,
                "CAT CDMA"
            ],
            [
                52002,
                "CAT CDMA"
            ],
            [
                52018,
                "DTAC"
            ],
            [
                52099,
                "True Move"
            ],
            [
                52010,
                "WCS IQ"
            ],
            [
                61503,
                "Moov"
            ],
            [
                61505,
                "Telecel"
            ],
            [
                61501,
                "Togo Cell"
            ],
            [
                53988,
                "Digicel"
            ],
            [
                53943,
                "Shoreline Communication"
            ],
            [
                53901,
                "Tonga Communications Corporation"
            ],
            [
                37412,
                "bmobile"
            ],
            [
                37413,
                "Digicel"
            ],
            [
                374130,
                "Digicel"
            ],
            [
                60501,
                "Orange"
            ],
            [
                60502,
                "Tunicell"
            ],
            [
                60503,
                "Tunisiana"
            ],
            [
                28603,
                "Avea"
            ],
            [
                28604,
                "Aycell"
            ],
            [
                28601,
                "Turkcell"
            ],
            [
                28602,
                "Vodafone"
            ],
            [
                43801,
                "MTS"
            ],
            [
                43802,
                "TM-Cell"
            ],
            [
                55301,
                "TTC"
            ],
            [
                64110,
                "MTN"
            ],
            [
                64114,
                "Orange"
            ],
            [
                64111,
                "Uganda Telecom Ltd."
            ],
            [
                64122,
                "Warid Telecom"
            ],
            [
                64101,
                "Zain"
            ],
            [
                25502,
                "Beeline"
            ],
            [
                25523,
                "CDMA Ukraine"
            ],
            [
                25505,
                "Golden Telecom"
            ],
            [
                25504,
                "IT"
            ],
            [
                25503,
                "Kyivstar"
            ],
            [
                25506,
                "life:)"
            ],
            [
                25501,
                "MTS"
            ],
            [
                25521,
                "PEOPLEnet"
            ],
            [
                25507,
                "Utel"
            ],
            [
                42403,
                "du"
            ],
            [
                42402,
                "Etisalat"
            ],
            [
                23420,
                "3 Hutchison"
            ],
            [
                23400,
                "BT"
            ],
            [
                23455,
                "Cable & Wireless / Sure Mobile (Isle of Man)"
            ],
            [
                23418,
                "Cloud9"
            ],
            [
                23403,
                "Jersey Telenet"
            ],
            [
                23450,
                "JT-Wave"
            ],
            [
                23458,
                "Manx Telecom"
            ],
            [
                23401,
                "MCom"
            ],
            [
                23402,
                "O2"
            ],
            [
                23410,
                "O2"
            ],
            [
                23411,
                "O2"
            ],
            [
                23433,
                "EE"
            ],
            [
                23434,
                "EE"
            ],
            [
                23412,
                "Railtrack"
            ],
            [
                23422,
                "Routo Telecom"
            ],
            [
                23409,
                "Sure Mobile"
            ],
            [
                23430,
                "EE"
            ],
            [
                23419,
                "Telaware"
            ],
            [
                234100,
                "Tesco Mobile"
            ],
            [
                23477,
                "Unknown"
            ],
            [
                23431,
                "Virgin"
            ],
            [
                23432,
                "Virgin"
            ],
            [
                23415,
                "Vodafone"
            ],
            [
                310880,
                "Advantage"
            ],
            [
                310850,
                "Aeris"
            ],
            [
                310640,
                "Airadigm"
            ],
            [
                310780,
                "Airlink PCS"
            ],
            [
                310034,
                "Airpeak"
            ],
            [
                310510,
                "Airtel"
            ],
            [
                310430,
                "Alaska Digitel"
            ],
            [
                310500,
                "Alltel"
            ],
            [
                310590,
                "Alltel"
            ],
            [
                310630,
                "AmeriLink PCS"
            ],
            [
                310038,
                "AT&T"
            ],
            [
                310090,
                "AT&T"
            ],
            [
                310150,
                "AT&T"
            ],
            [
                310170,
                "AT&T"
            ],
            [
                310410,
                "AT&T"
            ],
            [
                310560,
                "AT&T"
            ],
            [
                310680,
                "AT&T"
            ],
            [
                310380,
                "AT&T Mobility"
            ],
            [
                310980,
                "AT&T Mobility"
            ],
            [
                310990,
                "AT&T Mobility"
            ],
            [
                310830,
                "Caprock"
            ],
            [
                310350,
                "Carolina Phone"
            ],
            [
                311130,
                "Cell One Amarillo"
            ],
            [
                310320,
                "Cellular One"
            ],
            [
                310440,
                "Cellular One"
            ],
            [
                310390,
                "Cellular One of East Texas"
            ],
            [
                311190,
                "Cellular Properties"
            ],
            [
                310030,
                "Centennial"
            ],
            [
                311010,
                "Chariton Valley"
            ],
            [
                310570,
                "Chinook Wireless"
            ],
            [
                310480,
                "Choice Phone"
            ],
            [
                311120,
                "Choice Phone"
            ],
            [
                310420,
                "Cincinnati Bell"
            ],
            [
                311180,
                "Cingular Wireless"
            ],
            [
                310620,
                "Coleman County Telecom"
            ],
            [
                311040,
                "Commnet Wireless"
            ],
            [
                310040,
                "Concho"
            ],
            [
                310690,
                "Conestoga"
            ],
            [
                310060,
                "Consolidated Telcom"
            ],
            [
                310740,
                "Convey"
            ],
            [
                310080,
                "Corr"
            ],
            [
                310016,
                "Cricket Communications"
            ],
            [
                310940,
                "Digital Cellular"
            ],
            [
                310190,
                "Dutch Harbor"
            ],
            [
                311070,
                "Easterbrooke"
            ],
            [
                311160,
                "Endless Mountains Wireless"
            ],
            [
                310610,
                "Epic Touch"
            ],
            [
                311060,
                "Farmers Cellular"
            ],
            [
                311210,
                "Farmers Cellular"
            ],
            [
                310311,
                "Farmers Wireless"
            ],
            [
                310910,
                "First Cellular"
            ],
            [
                310300,
                "Get Mobile Inc"
            ],
            [
                310970,
                "Globalstar"
            ],
            [
                311100,
                "High Plains Wireless"
            ],
            [
                311110,
                "High Plains Wireless"
            ],
            [
                310070,
                "Highland Cellular"
            ],
            [
                310400,
                "i CAN_GSM"
            ],
            [
                310770,
                "i wireless"
            ],
            [
                311030,
                "Indigo Wireless"
            ],
            [
                310650,
                "Jasper"
            ],
            [
                311090,
                "Long Lines Wireless"
            ],
            [
                310010,
                "MCI"
            ],
            [
                310000,
                "Mid-Tex Cellular"
            ],
            [
                311000,
                "Mid-Tex Cellular"
            ],
            [
                311020,
                "Missouri RSA 5 Partnership"
            ],
            [
                310013,
                "MobileTel"
            ],
            [
                316010,
                "Nextel"
            ],
            [
                310017,
                "North Sight Communications Inc."
            ],
            [
                310670,
                "Northstar"
            ],
            [
                310540,
                "Oklahoma Western"
            ],
            [
                310870,
                "PACE"
            ],
            [
                310760,
                "Panhandle"
            ],
            [
                311170,
                "PetroCom"
            ],
            [
                311080,
                "Pine Cellular"
            ],
            [
                310790,
                "PinPoint"
            ],
            [
                310100,
                "Plateau Wireless"
            ],
            [
                310960,
                "Plateau Wireless"
            ],
            [
                310110,
                "PTI Pacifica"
            ],
            [
                310730,
                "SeaMobile"
            ],
            [
                310046,
                "SIMMETRY"
            ],
            [
                310460,
                "Simmetry"
            ],
            [
                316011,
                "Southern Communications Services"
            ],
            [
                310120,
                "Sprint"
            ],
            [
                311140,
                "Sprocket"
            ],
            [
                310490,
                "SunCom"
            ],
            [
                310026,
                "T-Mobile"
            ],
            [
                310160,
                "T-Mobile"
            ],
            [
                310200,
                "T-Mobile"
            ],
            [
                310210,
                "T-Mobile"
            ],
            [
                310220,
                "T-Mobile"
            ],
            [
                310230,
                "T-Mobile"
            ],
            [
                310240,
                "T-Mobile"
            ],
            [
                310250,
                "T-Mobile"
            ],
            [
                310260,
                "T-Mobile"
            ],
            [
                310270,
                "T-Mobile"
            ],
            [
                310280,
                "T-Mobile"
            ],
            [
                310290,
                "T-Mobile"
            ],
            [
                310310,
                "T-Mobile"
            ],
            [
                310330,
                "T-Mobile"
            ],
            [
                310580,
                "T-Mobile"
            ],
            [
                310660,
                "T-Mobile"
            ],
            [
                310800,
                "T-Mobile"
            ],
            [
                310900,
                "Taylor"
            ],
            [
                310014,
                "Testing"
            ],
            [
                310020,
                "Union Telephone Company"
            ],
            [
                310520,
                "VeriSign"
            ],
            [
                310004,
                "Verizon"
            ],
            [
                310012,
                "Verizon"
            ],
            [
                310450,
                "Viaero"
            ],
            [
                310180,
                "West Central"
            ],
            [
                310530,
                "West Virginia Wireless"
            ],
            [
                310340,
                "Westlink"
            ],
            [
                311050,
                "Wikes Cellular"
            ],
            [
                311150,
                "Wilkes Cellular"
            ],
            [
                310890,
                "Wireless Alliance"
            ],
            [
                310950,
                "XIT Wireless"
            ],
            [
                74800,
                "Ancel"
            ],
            [
                74801,
                "Ancel"
            ],
            [
                74810,
                "Claro"
            ],
            [
                74807,
                "Movistar"
            ],
            [
                43404,
                "Beeline"
            ],
            [
                43401,
                "Buztel"
            ],
            [
                43407,
                "MTS"
            ],
            [
                43406,
                "Perfectum Mobile"
            ],
            [
                43405,
                "Ucell"
            ],
            [
                43402,
                "Uzmacom"
            ],
            [
                54101,
                "SMILE"
            ],
            [
                73401,
                "Digitel"
            ],
            [
                73402,
                "Digitel"
            ],
            [
                73403,
                "Digitel"
            ],
            [
                73406,
                "Movilnet"
            ],
            [
                73404,
                "movistar"
            ],
            [
                45208,
                "3G EVNTelecom"
            ],
            [
                45207,
                "Beeline VN"
            ],
            [
                45206,
                "E-Mobile"
            ],
            [
                45205,
                "HT Mobile"
            ],
            [
                45201,
                "MobiFone"
            ],
            [
                45203,
                "S-Fone"
            ],
            [
                45204,
                "Viettel Mobile"
            ],
            [
                45202,
                "Vinaphone"
            ],
            [
                376350,
                "C&W"
            ],
            [
                33805,
                "Digicel"
            ],
            [
                376352,
                "Islandcom"
            ],
            [
                42104,
                "HiTS-UNITEL"
            ],
            [
                42102,
                "MTN"
            ],
            [
                42101,
                "SabaFon"
            ],
            [
                42103,
                "Yemen Mobile"
            ],
            [
                64502,
                "MTN"
            ],
            [
                64501,
                "Zain"
            ],
            [
                64503,
                "ZAMTEL"
            ],
            [
                64804,
                "Econet"
            ],
            [
                64801,
                "Net*One"
            ],
            [
                64803,
                "Telecel"
            ]
        ];
        return new Map(kvArray);
    }
};

